import { render, staticRenderFns } from "./SignatureDropzone.vue?vue&type=template&id=fdaff026&scoped=true"
import script from "./SignatureDropzone.vue?vue&type=script&lang=js"
export * from "./SignatureDropzone.vue?vue&type=script&lang=js"
import style0 from "./SignatureDropzone.vue?vue&type=style&index=0&id=fdaff026&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdaff026",
  null
  
)

export default component.exports